<template>
	<div class="SocialmediaCronWorks">

		<ListHeader :brands="brands" v-on:headerChanged="headerChanged($event)"/>

		<div class="SocialmediaCronWorksListBody">

			<template v-if="isLoading">
				<div class="text-xs-center pa-5">
					<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
					<div class="caption mt-4">Listeleniyor</div>
				</div>
			</template>

			<swiper :options="swiper">
				<swiper-slide v-for="(group,groupIndex) in works" :key="'work-table-swipe-'+groupIndex">
					<ListGroup 
					:brands="brands" 
					:group="group"
					v-on:editItem="editItem($event)"
					/>
				</swiper-slide>
			</swiper>
		</div>


		<v-btn fab bottom right color="pink" dark fixed @click="dialogEditor = true" class="btn-new-work">
			<v-icon>add</v-icon>
		</v-btn>
 
		<v-dialog v-model="dialogEditor" fullscreen hide-overlay transition="dialog-bottom-transition">
			<WorkEditor v-if="dialogEditor" :brands="brands" :editor_id="editor_id" v-on:closeEditor="closeEditor($event)"/> 
		</v-dialog>



	</div>
</template>


<script>
	import ListHeader from "./ListHeader"
	import ListGroup from "./ListGroup"
	import WorkEditor from "./WorkEditor"
	export default {
		name: "SocialmediaCronWorks",
		components: {
			ListHeader,
			ListGroup,
			WorkEditor,
			// WorkJobList,
			// WorkEditor
		},
		data: () => ({
			isLoading : false,
			swiper: {
				slidesPerView: "auto",
				spaceBetween: 5,
				freeMode: true
			},
			brands : [],
			works : [],
			filter : {},
			dialogEditor : false,
			editor_id : "",
 
		}),
		mounted() { 
			this.loadBrands()
		},
		watch: { 
		},
		methods: {
			headerChanged(e){ 
				this.filter = e
				this.loadWorks()
			},
			loadBrands(){
				this.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cron/brands/", {
					params: {
						id : this.id
					}
				}).then(response => {
					this.brands = response.body; 
				})
			},
			loadWorks(){
				var self = this;
				if(self.isLoading){
					return false;
				}
				self.isLoading = true;
				setTimeout(function(){
					self.$http.get(process.env.VUE_APP_API_URL + "/socialmedia/cron/works/", {
						params: self.filter
					}).then(response => {
						self.works = response.body; 
						self.isLoading = false;
					})
				},300)
			},
			editItem(id){
				this.editor_id = id;
				this.dialogEditor = true;
			},
			closeEditor(reload){
				this.dialogEditor = false;
				if(reload){
					this.loadWorks()
				}
			}
		},
		computed: {
			 
		}
	};
</script>


<style lang="less">
	.SocialmediaCronWorks {
		.workHeader {
			border-bottom: 2px solid #ccc;
			background-color: #fff;
			padding: 10px 10px 10px 10px;
		}

		.SocialmediaCronWorksListBody {
			margin: 10px;

			.swiper-slide {
				width: 300px;
			}
		}
	}
</style>